import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AdminAuthService } from './admin-auth.service';

export const adminAuthGuard: CanActivateFn = () => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/admin/login']);
};

export const adminGuestGuard: CanActivateFn = () => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return true;
  return router.createUrlTree(['/admin/tenants']);
};

/** Blocks a route when the admin lacks the required `data.permission`. */
export const adminPermissionGuard: CanActivateFn = (route) => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);
  const perm = route.data?.['permission'] as string | undefined;
  const allowed = !perm || auth.has(perm);
  return allowed ? true : router.createUrlTree(['/admin/tenants']);
};
